var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "css-4fx19t",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0B90B",
    d: "M230.997 512 116.053 626.987 0 512l116.01-116.01L230.998 512zM512 230.997l197.973 197.974 116.054-115.968L512 0 197.973 314.027l116.054 115.968L512 230.997zM907.99 395.99 793.002 512l116.01 116.01L1024.981 512 907.99 395.99zM512 793.003 314.027 594.005 197.973 710.016 512 1024l314.027-314.027-116.054-115.968L512 793.003zm0-165.974 116.01-116.053L512 396.032 395.99 512 512 626.987z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceLogo);
export default __webpack_public_path__ + "static/media/binance-logo.519756a77b420a85f2f4b74a5d702f42.svg";
export { ForwardRef as ReactComponent };